module.exports = __webpack_public_path__ + "img/civil_engineer_intro.1314cdbe.jpg";